module.exports = __webpack_public_path__ + "static/img/trial.7a5f960f.svg";